//@ts-ignore
import ReactHtmlParser from 'react-html-parser';

const CancelRefund = () => {
  const html = `
  <div class="appie-visible active " style="padding:30px;">
    <h3 class="appie-title">İptal ve İade Koşulları</h3>
</div>`;

  return <>{ReactHtmlParser(html)}</>;
};
export default CancelRefund;
